import { render, staticRenderFns } from "./alcohol-percentage.vue?vue&type=template&id=8842007e"
import script from "./alcohol-percentage.vue?vue&type=script&lang=js"
export * from "./alcohol-percentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports